import { useEffect, useRef, useState } from "react";
import { Mic, Square } from "lucide-react";
import { STT_SUPPORTED, startRecognition } from "../lib/webSpeech.js";

export function appendTranscript(previous, chunk) {
  const base = String(previous || "").trimEnd();
  const next = String(chunk || "").trim();
  if (!next) return previous;
  if (!base) return next;
  return `${base} ${next}`;
}

export default function SpeechToTextButton({
  onTranscript,
  onError,
  lang = "en-US",
  className = "",
}) {
  const stopRef = useRef(null);
  const [listening, setListening] = useState(false);

  const stop = () => {
    stopRef.current?.();
    stopRef.current = null;
    setListening(false);
  };

  useEffect(() => () => stopRef.current?.(), []);

  const start = () => {
    if (!STT_SUPPORTED) {
      onError?.("Speech recognition is not supported in this browser.");
      return;
    }
    const stopRecognition = startRecognition({
      lang,
      onResult: ({ text, isFinal }) => {
        if (!isFinal || !text) return;
        onTranscript?.(text);
      },
      onError: (err) => {
        onError?.(typeof err === "string" ? err : err?.message || "Microphone error");
        stop();
      },
    });
    stopRef.current = stopRecognition;
    setListening(true);
  };

  if (!STT_SUPPORTED) return null;

  return listening ? (
    <button
      type="button"
      onClick={stop}
      className={`btn-ghost !py-1.5 !px-2 text-xs ${className}`}
      title="Stop dictation"
    >
      <Square className="h-3.5 w-3.5 fill-current" />
      Stop mic
    </button>
  ) : (
    <button
      type="button"
      onClick={start}
      className={`btn-ghost !py-1.5 !px-2 text-xs ${className}`}
      title="Start speech to text"
    >
      <Mic className="h-3.5 w-3.5" />
      Mic
    </button>
  );
}
